<template>
  <div>
    <div class="content">
      <!-- <div class="title">企业信息完善</div> -->
      <div class="contNr">
        <div class="contentRit">
          <!-- <div class="titles">公司资料填写</div>
          <div class="leixing">
            <div
              class="box dis-cent"
              v-for="(item, index) in lxList"
              :class="lxOn == index ? 'on' : ''"
              @click="lxClick(index)"
            >
              {{ item }}
            </div>
          </div> -->
          <div class="titleBox">
            <div class="shu"></div>
            <div class="name">编辑公司信息</div>
          </div>
          <div class="tyTxt">
            请认真阅读并遵守《<span>公司信息填写须知</span>》
          </div>
          <div class="xyCont">
            <div class="xyHead">
              <div class="text">你的公司主页吸引力</div>
              <div class="zt">
                {{ num == 0 ? "优秀" : num == 1 ? "良好" : "一般" }}
              </div>
            </div>
            <div class="txt">
              {{
                num == 0
                  ? "已完善全部资料"
                  : num == 1
                    ? "达到同行基础水平，完善全部资料增加竞争力"
                    : "未达到同行业基础水平，影响招聘"
              }}
            </div>
            <div class="ts">完善信息，可以提升公司主页曝光率</div>
          </div>
          <div class="typeList">
            <div class="typeBox" :class="lxOn == 0 ? 'on' : ''" @click="typeClick(0)">
              <div class="text">公司基本信息</div>
              <div class="box">
                <div class="txt" v-if="jb == 0">未完善</div>
                <div class="iconfont icon-enter enter"></div>
              </div>
            </div>
            <div class="typeBox" @click="typeClick(2)" :class="lxOn == 2 ? 'on' : ''">
              <div class="text">公司福利</div>
              <div class="box">
                <div class="txt" v-if="fl == 0">未完善</div>
                <div class="iconfont icon-enter enter"></div>
              </div>
            </div>
            <div class="typeBox" @click="typeClick(3)" :class="lxOn == 3 ? 'on' : ''">
              <div class="text">公司相册</div>
              <div class="box">
                <div class="txt" v-if="!imgs">未完善</div>
                <div class="iconfont icon-enter enter"></div>
              </div>
            </div>
            <div class="typeBox" :class="lxOn == 1 ? 'on' : ''" @click="typeClick(1)">
              <div class="text">营业执照</div>
              <div class="box">
                <div class="txt"></div>
                <div class="iconfont icon-enter enter"></div>
              </div>
            </div>
            <div class="typeBox" :class="lxOn == 4 ? 'on' : ''" @click="typeClick(4)">
              <div class="text">人员管理</div>
              <div class="box">
                <div class="txt"></div>
                <div class="iconfont icon-enter enter"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- 基本信息 -->
        <div class="contBox">
          <div v-show="lxOn == 0">
            <div class="cont">
              <div class="titleBox">
                <div class="shu"></div>
                <div class="name">公司基本信息</div>
              </div>
              <div class="box mab15">
                <div class="name">公司logo</div>
                <div class="imgsBox">
                  <div class="img dis-cent" v-if="!logoImg" @click="uploadFile(3)">
                    <div class="iconfont icon-camera_fill"></div>
                  </div>
                  <div class="img" v-if="logoImg" @click="uploadFile(3)">
                    <img :src="$imgUrl + logoImg" alt="" />
                  </div>
                </div>
              </div>
              <div class="box">
                <div class="name">企业账号<span>*</span></div>
                <div class="inpBox">
                  <div class="inp">
                    <input v-model="memberData.account" type="text" disabled placeholder="请输入企业账号" />
                  </div>
                </div>
              </div>
              <div class="box">
                <div class="name">联系人<span>*</span></div>
                <div class="inpBox">
                  <div class="inp">
                    <input v-model="person" type="text" placeholder="请输入联系人" />
                  </div>
                </div>
              </div>
              <div class="box">
                <div class="name">联系方式<span>*</span></div>
                <div class="inpBox">
                  <div class="inp">
                    <input v-model="mobile" type="text" placeholder="请输入联系方式" />
                  </div>
                </div>
              </div>
              <div class="box">
                <div class="name">企业规模<span>*</span></div>
                <div class="inpBox">
                  <a-dropdown>
                    <div class="xzBox" :class="size_id ? 'on' : ''">
                      <div class="text">{{ size }}</div>
                      <div class="iconfont icon-enter"></div>
                    </div>
                    <a-menu slot="overlay" @click="gmClick" :selectedKeys="[district]">
                      <a-menu-item :key="'企业规模_' + item.id + '_' + item.c_name" v-for="item in scale">{{ item.c_name
                      }}</a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </div>
              </div>
              <div class="box">
                <div class="name">公司性质<span>*</span></div>
                <div class="inpBox">
                  <a-dropdown>
                    <div class="xzBox" :class="nature ? 'on' : ''">
                      <div class="text">{{ nature_cn }}</div>
                      <div class="iconfont icon-enter"></div>
                    </div>
                    <a-menu slot="overlay" @click="hyClick" :selectedKeys="[nature]">
                      <a-menu-item :key="'公司性质_' + item.id + '_' + item.c_name" v-for="item in company">{{ item.c_name
                      }}</a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </div>
              </div>
              <div class="box">
                <div class="name">办公区域<span>*</span></div>
                <div class="inpBox">
                  <div class="xzBox" :class="district.length ? 'on' : ''" @click="districtClick">
                    <div class="text">{{ district_cn || '请选择办公区域' }}</div>
                    <div class="iconfont icon-enter"></div>
                  </div>
                </div>
              </div>
              <div class="box">
                <div class="name">公司行业<span>*</span></div>
                <div class="inpBox">
                  <div class="xzBox" :class="tradeOn ? 'on' : ''" @click="tradeClick">
                    <div class="text">{{ tradeTxt }}</div>
                    <div class="iconfont icon-enter"></div>
                  </div>
                </div>
              </div>
              <div class="box">
                <div class="name">公司产业<span>*</span></div>
                <div class="inpBox">
                  <a-dropdown>
                    <div class="xzBox" :class="industry_id ? 'on' : ''">
                      <div class="text">{{ industry_cn }}</div>
                      <div class="iconfont icon-enter"></div>
                    </div>
                    <a-menu slot="overlay" @click="hyClick" :selectedKeys="[industryOn]">
                      <a-menu-item :key="'公司产业_' + item.id + '_' + item.name" v-for="item in industry">{{ item.name
                      }}</a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </div>
              </div>
              <div class="box">
                <div class="name">详细地址<span>*</span></div>
                <div class="areaBox">
                  <a-input-search placeholder="搜索地址" enter-button @search="handleSearchauto" id="mapSearch"
                    v-model="searchValue" style="width: 100%" />
                  <div class="map">
                    <div style="height: 15px"></div>
                    <div :style="{ width: '100%', height: '350px' }" id="getMap"></div>
                  </div>
                </div>
              </div>
              <div class="box">
                <div class="name">邮箱</div>
                <div class="inpBox">
                  <div class="inp">
                    <input v-model="email" type="text" placeholder="请输入邮箱" />
                  </div>
                </div>
              </div>
              <div class="box">
                <div class="name">网址</div>
                <div class="inpBox">
                  <div class="inp">
                    <input v-model="url" type="text" placeholder="请输入网址" />
                  </div>
                </div>
              </div>
              <div class="box">
                <div class="name">公司简介</div>
                <div class="textareaBox">
                  <div class="textarea">
                    <textarea v-model="content" placeholder="请输入公司简介"></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="lxOn == 2">
            <div class="cont">
              <div class="titleBox">
                <div class="shu"></div>
                <div class="name">公司资料</div>
              </div>
              <div class="box">
                <div class="name">上班时间</div>
                <div class="inpBox">
                  <div class="inp">
                    <input type="text" v-model="gotowork" placeholder="请输入上班时间，如：上午09:00 - 下午06:30" />
                  </div>
                </div>
              </div>
              <div class="box mab15">
                <div class="name">加班情况</div>
                <div class="selectCont">
                  <div class="seLi dis-cent" :class="item.id == jbTypeOn ? 'on' : ''" v-for="item in jbTypeList"
                    @click="jbTypeClick(item.id)">
                    {{ item.name }}
                  </div>
                </div>
              </div>
              <div class="box mab15">
                <div class="name">有无加班费</div>
                <div class="selectCont">
                  <div class="seLi dis-cent" :class="item.id == jbfTypeOn ? 'on' : ''" v-for="item in jbfTypeList"
                    @click="jbfTypeClick(item.id)">
                    {{ item.name }}
                  </div>
                </div>
              </div>
              <div class="box mab15">
                <div class="name">公司福利</div>
                <div class="selectCont">
                  <div class="seLi dis-cent" :class="item.select ? 'on' : ''" v-for="(item, index) in jobtag"
                    @click="jobtagClick(index)">
                    {{ item.c_name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="lxOn == 3">
            <div class="cont">
              <div class="titleBox">
                <div class="shu"></div>
                <div class="name">公司相册</div>
              </div>
              <div class="box mab15">
                <div class="name">公司相册</div>
                <div class="imgsBox">
                  <div class="img dis-cent" v-if="imgs.length < 9" @click="uploadFile(2)">
                    <div class="iconfont icon-camera_fill"></div>
                  </div>
                  <div class="img" v-for="(item, index) in imgs">
                    <img :src="$imgUrl + item.path_name" alt="" />
                    <div class="cha dis-cent" @click="imgDelClick(index)">
                      <div class="iconfont icon-close"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="lxOn == 1">
            <div class="cont">
              <div class="titleBox">
                <div class="shu"></div>
                <div class="name">营业执照信息</div>
              </div>
              <div>
                <div class="box bz">
                  <div class="bzBox">
                    <div class="name">营业执照<span>*</span></div>
                    <div class="imgBox">
                      <!-- <div class="img dis-cent" v-if="!imgUp" @click="uploadFile(1)">
                        <div class="iconfont icon-camera_fill"></div>
                      </div>
                      <div class="img" v-if="imgUp" @click="uploadFile(1)">
                        <img :src="$imgUrl + imgUp" alt="" />
                      </div> -->
                      <div class="img dis-cent" v-if="!imgUp">
                        <div class="iconfont icon-camera_fill"></div>
                      </div>
                      <div class="img" v-if="imgUp">
                        <img :src="$imgUrl + imgUp" alt="" />
                      </div>
                    </div>
                  </div>
                  <div class="bzTxt">
                    备注：上传公司营业执照图片，自动识别内容
                  </div>
                </div>
                <div class="box">
                  <div class="name">公司名称<span>*</span></div>
                  <div class="inpBox">
                    <div class="inp">
                      <input type="text" disabled v-model="comInfo.name" placeholder="请输入公司名称" />
                    </div>
                  </div>
                </div>
                <div class="box">
                  <div class="name">法定代表人<span>*</span></div>
                  <div class="inpBox">
                    <div class="inp">
                      <input type="text" disabled v-model="comInfo.representative" placeholder="请输入法定代表人" />
                    </div>
                  </div>
                </div>
                <div class="box">
                  <div class="name">成立日期<span>*</span></div>
                  <div class="inpBox">
                    <div class="inp">
                      <input type="text" disabled v-model="comInfo.establish_time" placeholder="请输入成立日期" />
                    </div>
                  </div>
                </div>
                <div class="box">
                  <div class="name">企业类型<span>*</span></div>
                  <div class="inpBox">
                    <div class="inp">
                      <input type="text" disabled v-model="comInfo.cmpanytype" placeholder="请输入企业类型" />
                    </div>
                  </div>
                </div>
                <div class="box">
                  <div class="name">注册资金<span>*</span></div>
                  <div class="inpBox">
                    <div class="inp">
                      <input type="text" v-model="comInfo.fund" disabled placeholder="请输入注册资金" />
                    </div>
                  </div>
                </div>
                <div class="box">
                  <div class="name">注册地址<span>*</span></div>
                  <div class="inpBox">
                    <div class="inp">
                      <input type="text" disabled v-model="comInfo.residence" placeholder="请输入注册地址" />
                    </div>
                  </div>
                </div>
                <div class="box">
                  <div class="name">营业期限<span>*</span></div>
                  <div class="inpBox">
                    <div class="inp">
                      <input type="text" disabled v-model="comInfo.trade_time" placeholder="请输入营业期限" />
                    </div>
                  </div>
                </div>
                <div class="box">
                  <div class="name">统一社会信用代码<span>*</span></div>
                  <div class="inpBox">
                    <div class="inp">
                      <input type="text" disabled v-model="comInfo.yyzz" placeholder="请输入统一社会信用代码" />
                    </div>
                  </div>
                </div>
                <div class="box">
                  <div class="name">核准日期<span>*</span></div>
                  <div class="inpBox">
                    <div class="inp">
                      <input type="text" disabled v-model="comInfo.approval" placeholder="请输入核准日期" />
                    </div>
                  </div>
                </div>
                <div class="box">
                  <div class="name">登记机关<span>*</span></div>
                  <div class="inpBox">
                    <div class="inp">
                      <input type="text" disabled v-model="comInfo.registration" placeholder="请输入登记机关" />
                    </div>
                  </div>
                </div>
                <div class="box">
                  <div class="name">经营范围<span>*</span></div>
                  <div class="textareaBox">
                    <div class="textarea">
                      <textarea disabled v-model="comInfo.ranges" placeholder="请输入经营范围"></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <GsChengyuan v-show="lxOn == 4" />
          <div class="btns" v-show="lxOn == 0 || lxOn == 2 || lxOn == 3">
            <!-- <div class="btn dis-cent">取消</div> -->
            <div class="btn dis-cent" @click="saveClick" v-if="lxOn != 1">
              提交
            </div>
          </div>
        </div>
      </div>
    </div>
    <input type="file" accept="image/*" ref="fileInput" @change="onFileChange" style="display: none" />
    <input type="file" accept="image/*" ref="imgsfileInput" @change="onimgsFileChange" style="display: none" />
    <input type="file" accept="image/*" ref="logofileInput" @change="onlogoFileChange" style="display: none" />
    <XuanzeLd v-if="ldShow" :ldData="tradeData" @show="ldShowDelClick" />
    <XuanzeQy v-if="quShow" :qyData="{ areaList: areaList, district: district, district_cn: district_cn }" @show="quDelClick" />
  </div>
</template>

<script>
import {
  Select,
  Form,
  Menu,
  Input,
  Button,
  Upload,
  Icon,
  Dropdown,
} from "ant-design-vue";
import TiandituLoader from "@/assets/js/tianditu";
import XuanzeLd from "../component/xuanzeLd.vue";
import XuanzeQy from "../component/xuanzeQy.vue";
import GsChengyuan from "../gongsi/gsChengyuan/gsChengyuan.vue";
export default {
  components: {
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-form": Form,
    "a-form-item": Form.Item,
    "a-input": Input,
    "a-input-search": Input.Search,
    "a-button": Button,
    "a-textarea": Input.TextArea,
    "a-dropdown": Dropdown,
    "a-upload": Upload,
    "a-icon": Icon,
    "a-menu": Menu,
    "a-menu-item": Menu.Item,
    "a-sub-menu": Menu.SubMenu,
    XuanzeLd,
    XuanzeQy,
    GsChengyuan,
  },
  name: "",
  data() {
    return {
      tiandituApi: null,
      ldShow: false,
      quShow: false,
      jobtagOn: 0,
      jobtag: [],
      size: "default",
      lxOn: 0,
      lxList: ["详细信息", "营业执照"],
      searchValue: "",
      center: [121.219406, 28.119613],
      typeOn: 1,
      typeList: [
        {
          name: "个人求职注册",
          id: 1,
        },
        {
          name: "企业注册",
          id: 2,
        },
      ],
      yzmShow: false,
      gsTypeOn: 2,
      gsTypeList: [
        {
          name: "是",
          id: 1,
        },
        {
          name: "否",
          id: 2,
        },
      ],
      data: [
        {
          value: "111",
          text: "111",
        },
      ],
      value: undefined,
      imgUp: "",
      comInfo: {},
      imgs: [],
      welfare: [],
      jbTypeOn: 0,
      jbTypeList: [
        {
          id: 1,
          name: "经常加班",
        },
        {
          id: 2,
          name: "偶尔加班",
        },
        {
          id: 3,
          name: "基本不加班",
        },
      ],
      jbfTypeOn: 0,
      jbfTypeList: [
        {
          id: 1,
          name: "有",
        },
        {
          id: 2,
          name: "没有",
        },
      ],
      district:[],
      district_cn: "请选择办公区域",
      areaList: [
        {
          id: 3723,
          pid: 1146,
          code: 0,
          name: "玉城",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3724,
          pid: 1146,
          code: 0,
          name: "坎门",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3725,
          pid: 1146,
          code: 0,
          name: "大麦屿",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3726,
          pid: 1146,
          code: 0,
          name: "楚门",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3727,
          pid: 1146,
          code: 0,
          name: "清港",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3728,
          pid: 1146,
          code: 0,
          name: "龙溪",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3729,
          pid: 1146,
          code: 0,
          name: "芦浦",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3730,
          pid: 1146,
          code: 0,
          name: "沙门",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3731,
          pid: 1146,
          code: 0,
          name: "干江",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3732,
          pid: 1146,
          code: 0,
          name: "鸡山",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3733,
          pid: 1146,
          code: 0,
          name: "海山",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
      ],
      tradeOn: "",
      tradeTxt: "请选择公司行业",
      tradeData: {
        tradeTxt: "",
      },
      logoImg: "",
      size: "请选择企业规模",
      size_id: "",
      email: "",
      url: "",
      name: "",
      qDpassword: "",
      password: "",
      mobile: "",
      scale: [],
      content: "",
      gotowork: "",
      mobile: "",
      person: "",
      fl: 1,
      jb: 1,
      num: 0,
      industry_id: "",
      industry_cn: "请选择公司产业",
      industryOn: "",
      industry: [],
      nature: "",
      nature_cn: "请选择公司性质",
      company: [],
      memberData: {},
    };
  },
  created() {
    const that = this;
    TiandituLoader.load().then((Tianditu) => {
      that.tiandituApi = Tianditu;
      Tianditu.plugin("Tianditu.Geolocation", function () {
        var geolocation = new Tianditu.Geolocation({
          // 是否使用高精度定位，默认：true
          enableHighAccuracy: true,
          // 设置定位超时时间，默认：无穷大
          timeout: 10000,
          // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
          buttonOffset: new Tianditu.Pixel(10, 20),
          //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          zoomToAccuracy: true,
          //  定位按钮的排放位置,  RB表示右下
          buttonPosition: "RB",
        });
        geolocation.getCurrentPosition(function (status, result) {
          if (status === "complete") {
            that.showMap(Tianditu);
          } else {
            that.showMap(Tianditu);
          }
        });
      });
    });
    // this.mapinit()
    let category_gets = window.localStorage.getItem("category_gets");
    if (category_gets) {
      this.category_gets = JSON.parse(category_gets);
      this.typeHcGet(this.category_gets);
    } else {
      this.typeGet();
    }
    this.get();
    this.industry_get();
    let memberData = JSON.parse(window.localStorage.getItem('member'))
    if (memberData) {
      this.memberData = memberData
    } else {
      this.member_info_nav_get()
    }
  },
  methods: {
    member_info_nav_get() {
      this.$get("/nozzle/web/member_info_nav").then((res) => {
        console.log(res);
        this.memberData = res.data
        window.localStorage.setItem(
          "member",
          JSON.stringify(res.data)
        );
        window.localStorage.setItem("utype", res.data.utype);
      });
    },
    industry_get() {
      this.$get("/common/industry_gets", {
        pageNo: -1,
      }).then((res) => {
        this.industry = res.data;
        console.log(res);
      });
    },
    get() {
      this.$get("/nozzle/web/company_info").then((res) => {
        this.info = res.data;
        this.logoImg = res.data.logo;
        if (res.data.size) {
          this.size = res.data.size;
          this.size_id = res.data.size_id;
        }
        let dids = (res.data.district || "").split("|").map(g => g.replace("1142,1146,", ""));
        let dnames = (res.data.district_cn || "").split("|").map(n => n.replace("台州/玉环/", "")).filter(Boolean);
        this.district = dids.filter(Boolean);
        this.district_cn = dnames.join(",");
        this.tradeData.tradeOn = res.data.trade;
        this.tradeData.tradeTxt = res.data.trade_cn;
        this.nature = "公司性质_" + res.data.nature + "_" + this.nature_cn;
        this.nature_cn = res.data.nature_cn;
        this.tradeOn = res.data.trade;
        this.tradeTxt = res.data.trade_cn;
        if (res.data.industry_cn) {
          this.industry_id = res.data.industry_id;
          this.industry_cn = res.data.industry_cn;
        }
        this.searchValue = res.data.address;
        this.center = [res.data.lng, res.data.lat];
        this.url = res.data.url;
        this.person = res.data.person;
        this.mobile = res.data.mobile;
        this.email = res.data.email;
        this.content = res.data.content;
        this.gotowork = res.data.gotowork;
        this.jbTypeOn = res.data.worktime;
        this.jbfTypeOn = res.data.workprice;
        this.flGet(res.data.welfare);
        this.welfare = res.data.welfare;
        this.imgUp = res.data.certificate_img;
        this.comInfo.name = res.data.name;
        this.comInfo.representative = res.data.representative;
        this.comInfo.establish_time = res.data.establish_time;
        this.comInfo.cmpanytype = res.data.cmpanytype;
        this.comInfo.fund = res.data.fund + res.data.fund_type;
        this.comInfo.residence = res.data.residence;
        this.comInfo.trade_time = res.data.trade_time;
        this.comInfo.yyzz = res.data.yyzz;
        this.comInfo.approval = res.data.approval;
        this.comInfo.registration = res.data.registration;
        this.comInfo.ranges = res.data.ranges;
        this.imgs = res.data.resources ? res.data.resources : [];
        if (
          !res.data.gotowork ||
          !res.data.worktime ||
          !res.data.workprice ||
          !res.data.welfare
        ) {
          this.num++;
          this.fl = 0;
        }
        if (
          !res.data.logo ||
          !res.data.size_id ||
          this.district.length === 0 ||
          !res.data.nature ||
          !res.data.address ||
          !res.data.content
        ) {
          this.num++;
          this.jb = 0;
        }
      });
    },
    flGet(data) {
      data = data.split(",");
      for (let i = 0; i < this.jobtag.length; i++) {
        const e = this.jobtag[i];
        for (let j = 0; j < data.length; j++) {
          const ej = data[j];
          if (ej == e.c_name) {
            e.select = true;
          }
        }
      }
    },
    typeClick(i) {
      this.lxOn = i;
    },
    saveClick() {
      let data = {
        ...this.info,
      };
      if (this.lxOn == 0) {
        data.logo = this.logoImg;
        data.size = this.size;
        data.size_id = Number(this.size_id);
        data.person = this.person;
        data.mobile = this.mobile;
        data.district = this.district.map(id => "1142,1146," + id).join("|");
        data.district_cn = "台州/玉环/" + this.district_cn.split(",").join("|台州/玉环/");
        data.trade = Number(this.tradeOn);
        data.trade_cn = this.tradeTxt;
        data.nature = Number(this.nature.split("_")[1]);
        data.nature_cn = this.nature_cn;
        data.industry_id = Number(this.industry_id);
        data.industry_cn = this.industry_cn;
        data.address = this.searchValue;
        data.lng = Number(this.center[0]);
        data.lat = Number(this.center[1]);
        data.email = this.email;
        data.url = this.url;
        data.content = this.content;
      }
      if (this.lxOn == 2) {
        data.gotowork = this.gotowork;
        data.worktime = this.jbTypeOn;
        data.workprice = this.jbfTypeOn;
        data.welfare = this.welfare;
      }
      if (this.lxOn == 1) {
        data = {
          ...this.comInfo,
        };
      }
      if (this.lxOn == 3) {
        data.resource = this.imgs.map((res) => res.id).join(",");
      }
      console.log(data);
      data = JSON.stringify(data);
      this.$post("/nozzle/web/company_save", {
        avatars: this.avatars,
        data: data,
      }).then((res) => {
        if (res.data.status == 1) {
          this.$message.success("修改成功");
          this.$emit("show", 1);
        }
      });
    },
    tradeClick() {
      this.ldShow = true;
    },
    ldShowDelClick(data) {
      this.ldShow = false;
      if (data) {
        this.tradeData = data;
        this.tradeTxt = data.tradeTxt;
        this.tradeOn = data.tradeOn;
      }
    },
    districtClick() {
      this.quShow = true;
    },
    quDelClick(data) {
      this.quShow = false;
      if (data) {
        this.district = data.district;
        this.district_cn = data.district_cn;
      }
    },
    hyClick(e) {
      let key = e.key.split("_");
      if (key[0] == "公司产业") {
        this.industryOn = e.key;
        this.industry_id = key[1];
        this.industry_cn = key[2];
      }
      if (key[0] == "公司性质") {
        this.nature = e.key;
        this.nature_cn = key[2];
      }
      console.log(this.nature);
    },
    gmClick(e) {
      let key = e.key.split("_");
      this.size = key[2];
      this.size_id = key[1];
    },
    jbTypeClick(name) {
      this.jbTypeOn = name;
    },
    jbfTypeClick(name) {
      this.jbfTypeOn = name;
    },
    typeGet() {
      this.$get("/common/category_gets", {
        pageNo: -1,
      }).then((res) => {
        window.localStorage.setItem("category_gets", JSON.stringify(res.data));
        this.typeHcGet(res.data);
      });
    },
    typeHcGet(data) {
      // 职位亮点
      let jobtag = [];
      // 企业规模
      let scale = [];
      // 企业性质
      let company = [];
      for (let i = 0; i < data.length; i++) {
        const e = data[i];
        e.select = false;
        if (e.c_alias == "QS_jobtag") {
          jobtag.push(e);
        }
        if (e.c_alias == "QS_scale") {
          scale.push(e);
        }
        if (e.c_alias == "QS_company_type") {
          company.push(e);
        }
      }
      this.scale = scale;
      this.jobtag = jobtag;
      this.company = company;
    },
    jobtagClick(i) {
      this.jobtag[i].select = !this.jobtag[i].select;
      let welfare = [];
      for (let i = 0; i < this.jobtag.length; i++) {
        const e = this.jobtag[i];
        if (e.select) {
          welfare.push(e.c_name);
        }
      }
      welfare = welfare.join(",");
      this.welfare = welfare;
    },
    imgClick(e) {
      this.img = e;
    },
    onFileChange(e) {
      if (!e.target.files) {
        return;
      }
      var formData = new FormData();
      formData.append("file", e.target.files[0]);
      formData.append("where", "product");
      this.$uploadfile("/common/fileupload", formData).then((res) => {
        if (res.data.status) {
          this.imgUp = res.data.data.path_name;
          this.sbGet(res.data.data.path_name);
        } else {
          this.$message.error("网络繁忙,请稍后再试~");
        }
      });
    },
    sbGet(url) {
      this.$post("/nozzle/web/recognition", {
        url,
      }).then((res) => {
        let data = res.data.data.words_result;
        if (res.data.status == 1) {
          this.$message.success("识别成功");
          this.comInfo.name = data["单位名称"].words;
          this.comInfo.representative = data["法人"].words;
          this.comInfo.establish_time = data["成立日期"].words;
          this.comInfo.cmpanytype = data["类型"].words;
          this.comInfo.fund = data["注册资本"].words;
          this.comInfo.residence = data["地址"].words;
          this.comInfo.trade_time =
            data["有效期"].words + "-" + data["有效期"].words;
          this.comInfo.yyzz = data["社会信用代码"].words;
          this.comInfo.approval = data["核准日期"].words;
          this.comInfo.registration = data["登记机关"].words;
          this.comInfo.ranges = data["经营范围"].words;
          this.$forceUpdate();
        } else {
          this.$message.success(res.data.data.msg);
        }
      });
    },
    uploadFile(type) {
      if (type == 1) {
        this.$refs.fileInput.click();
      }
      if (type == 2) {
        this.$refs.imgsfileInput.click();
      }
      if (type == 3) {
        this.$refs.logofileInput.click();
      }
    },
    onimgsFileChange(e) {
      if (!e.target.files) {
        return;
      }
      var formData = new FormData();
      formData.append("file", e.target.files[0]);
      formData.append("where", "product");
      this.$uploadfile("/common/fileupload", formData).then((res) => {
        if (res.data.status) {
          this.imgs.push(res.data.data);
        } else {
          this.$message.error("网络繁忙,请稍后再试~");
        }
      });
    },
    onlogoFileChange(e) {
      if (!e.target.files) {
        return;
      }
      var formData = new FormData();
      formData.append("file", e.target.files[0]);
      formData.append("where", "product");
      this.$uploadfile("/common/fileupload", formData).then((res) => {
        if (res.data.status) {
          this.logoImg = res.data.data.path_name;
        } else {
          this.$message.error("网络繁忙,请稍后再试~");
        }
      });
    },
    imgDelClick(i) {
      this.imgs.splice(i, 1);
    },
    gsTypeClick(id) {
      this.gsTypeOn = id;
    },
    yzmClick() {
      if (!this.mobile) {
        this.$message.error("请先输入手机号");
        return;
      }
      this.yzmShow = true;
      this.timeYs = setInterval(() => {
        if (this.time == 0) {
          this.yzmShow = false;
          this.time = 60;
          clearInterval(this.timeYs);
        } else {
          this.time--;
        }
      }, 1000);
      this.$post("/common/sms_send", {
        mobile: this.mobile,
      }).then((res) => {
        if (res.data.status == 1) {
          this.$message.success("发送成功");
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // typeClick(id) {
    //   this.typeOn = id;
    // },
    mapinit() {
      this.map.remove(this.marker);
      this.addMark(this.map, this.center);
      this.map.setCenter(this.center);
    },
    showMap(Tianditu) {
      this.tiandituApi = Tianditu;
      this.maploading = true;
      this.map = new Tianditu.Map("getMap", {
        resizeEnable: true,
        center: this.center,
        zoom: 13,
      });
      this.marker = new Tianditu.Marker({
        position: this.center,
        offset: new Tianditu.Pixel(-13, -30),
      });
      // 添加点坐标

      this.map.add(this.marker);
      Tianditu.plugin(
        [
          "Tianditu.ToolBar",
          "Tianditu.Scale",
          "Tianditu.OverView",
          "Tianditu.MapType",
          "Tianditu.Geolocation",
          "Tianditu.Geocoder",
          "Tianditu.GeometryUtil",
        ],
        function () { }
      );
      const autoOptions = {
        input: "mapSearch",
        city: "331000",
      };
      const auto = new Tianditu.Autocomplete(autoOptions);
      this.placeSearch = new Tianditu.PlaceSearch({
        map: this.map,
        city: "331004",
      }); // 构造地点查询类
      this.maploading = false;
      Tianditu.event.addListener(auto, "select", this.select);
      this.map.on("click", (e) => {
        // 移除旧的点坐标
        this.map.remove(this.marker);
        // 获取点击的经纬度
        this.center = [e.lnglat.lng, e.lnglat.lat];
        // 植入新的点坐标
        this.lng = e.lnglat.lng;
        this.lat = e.lnglat.lat;
        this.map.setCenter(this.center);
        this.addMark(this.map, this.center);
        this.getAddress(this.center);
      });
    },
    select(e) {
      this.map.remove(this.marker);
      this.center = [e.poi.location.lng, e.poi.location.lat];
      this.addMark(this.map, this.center);
      this.map.setCenter(this.center);
      this.getAddress(this.center);
    },
    addMark(map, points) {
      // eslint-disable-next-line no-undef
      this.marker = new this.tiandituApi.Marker({
        map: map,
        position: points,
        draggable: true, // 允许拖动
        cursor: "move",
        raiseOnDrag: true,
        title: "中心",
      });
      this.marker.on("dragend", (e) => {
        const position = this.marker.getPosition();
        // 存下坐标与地址
        this.point = [position.lng, position.lat];
        this.lng = position.lng;
        this.lat = position.lat;
        this.center = [position.lng, position.lat];
        this.getAddress([position.lng, position.lat]);
      });
    },
    getAddress(points) {
      // eslint-disable-next-line no-undef
      const geocoder = new this.tiandituApi.Geocoder({ radius: 1000 });
      geocoder.getAddress(points, (status, result) => {
        if (status === "complete" && result.regeocode) {
          // eslint-disable-next-line camelcase
          const s_addr =
            result.regeocode.addressComponent.province +
            "-" +
            result.regeocode.addressComponent.city +
            "-" +
            result.regeocode.addressComponent.district;
          const addreesd = result.regeocode.formattedAddress; // 全部地址名称
          const houzhi = addreesd.substring(s_addr.length); // 获取具体街道

          this.addressText = addreesd;
          this.address = addreesd;
          this.searchValue = addreesd;
          // this.address = s_addr + "," + houzhi;
        }
      });
    },
    handleSearchauto(e) {
      this.dataSource = [];
      this.searchValue = e;
      this.placeSearch.search(this.searchValue, (status, result) => {
        if (result.poiList.pois) {
          this.map.remove(this.marker);
          this.center = [
            result.poiList.pois[0].location.lng,
            result.poiList.pois[0].location.lat,
          ];
          this.addMark(this.map, this.center);
          this.map.setCenter(this.center);
          this.getAddress(this.center);
        }
      });
    },
    lxClick(i) {
      this.lxOn = i;
    },
    btns() { },
  },
  mounted() { },
  computed: {},
};
</script>
<style lang="less" scoped>
/deep/.ant-select-selection--single {
  height: 36px;

}

/deep/.ant-select-selection__rendered {
  line-height: 35px;
}

.btBox {
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
  background-color: #fff;
  box-shadow: 0 2px 2px 1px whitesmoke;
  font-family: PingFangSC-Regular, sans-serif;

  .cont {
    width: 1440px;
    margin: auto;
    display: flex;
    height: 55px;
    align-items: center;
    justify-content: space-between;

    .logoimg {
      height: 30px;
      display: flex;
      align-items: center;

      img {
        height: 100%;
        width: auto;
      }

      .shu {
        width: 1px;
        height: 15px;
        margin: 0 10px;
        background-color: #999;
      }

      .name {
        font-size: 18px;
        font-weight: 700;
        color: #333;
      }
    }
  }
}

.content {
  width: 1280px;
  margin: auto;
  margin-top: 15px;
  border-radius: 10px;
  margin-bottom: 60px;
  // background-color: #fff;
  // padding: 40px;
  position: relative;

  .title {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
  }

  .contNr {
    display: flex;
    border-radius: 10px;
    border: 1px solid #ebebeb;
    overflow: hidden;
  }

  .contBox {
    width: 790px;
    background-color: #fff;
  }

  .cont {
    padding: 20px 30px;
    padding-bottom: 0;

    .titleBox {
      display: flex;
      align-items: center;
      margin-bottom: 30px;

      .shu {
        width: 4px;
        border-radius: 4px;
        height: 20px;
        background-color: #1382eb;
      }

      .name {
        font-weight: 600;
        font-size: 16px;
        margin-left: 10px;
      }
    }

    .bz {
      flex-direction: column;
    }

    .box {
      margin-bottom: 30px;
      display: flex;
      width: 700px;

      .bzBox {
        display: flex;
      }

      .bzTxt {
        padding-left: 100px;
        font-size: 12px;
        color: #9c9c9c;
        margin-top: 5px;
      }

      .name {
        width: 100px;
        margin-top: 6px;
        padding-right: 10px;

        span {
          color: #ee0909;
        }
      }

      .inpBox {
        width: calc(100% - 100px);
        height: 35px;
        position: relative;

        .xzBox {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 100%;
          box-sizing: border-box;
          border: 1px solid #ebebeb;
          border-radius: 5px;
          box-sizing: border-box;
          padding: 0 15px;
          color: #888;
          cursor: pointer;
        }

        .on {
          color: #000;
        }

        .inp {
          height: 100%;
          box-sizing: border-box;
          border: 1px solid #ebebeb;
          border-radius: 5px;
          box-sizing: border-box;
          padding-left: 15px;

          input {
            width: 100%;
            height: 100%;
          }
        }

        .yzmBox {
          position: absolute;
          top: 1px;
          right: 1px;
          width: 80px;
          height: calc(100% - 2px);
          background-color: #0864ce;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          font-size: 12px;
        }

        .anxia {
          background-color: #999;
        }
      }

      .areaBox {
        width: calc(100% - 100px);
        height: 400px;

        .img {
          width: 300px;
          height: 200px;
          box-sizing: border-box;
          border: 1px solid #ebebeb;
          border-radius: 5px;

          .iconfont {
            font-size: 40px;
            color: #c9c9c9;
          }
        }
      }

      .imgBox {
        width: calc(100% - 100px);
        box-sizing: border-box;

        .img {
          width: 300px;
          height: 200px;
          box-sizing: border-box;
          border: 1px solid #ebebeb;
          border-radius: 5px;
          cursor: pointer;

          .iconfont {
            font-size: 40px;
            color: #c9c9c9;
          }
        }
      }

      .imgsBox {
        width: calc(100% - 100px);
        display: flex;
        flex-wrap: wrap;

        .img {
          width: calc(33.33% - 10px);
          height: 120px;
          border-radius: 5px;
          border: 1px solid #ebebeb;
          color: #9c9c9c;
          margin-right: 15px;
          margin-bottom: 15px;
          cursor: pointer;
          position: relative;

          .iconfont {
            font-size: 30px;
          }

          .cha {
            position: absolute;
            top: 0;
            right: 0;
            width: 22px;
            height: 22px;
            border-bottom-left-radius: 5px;
            background-color: rgba(0, 0, 0, 0.4);
            color: #fff;
            cursor: pointer;

            .iconfont {
              font-size: 12px;
            }
          }
        }

        .img:nth-child(3n) {
          margin-right: 0;
        }
      }

      .textareaBox {
        width: calc(100% - 100px);
        height: 200px;

        .textarea {
          width: 600px;
          height: 100%;
          box-sizing: border-box;
          border: 1px solid #ebebeb;
          border-radius: 5px;
          box-sizing: border-box;
          padding: 10px 15px;

          textarea {
            width: 100%;
            height: 100%;
            border: none;
            resize: none;
          }
        }
      }

      .selectCont {
        overflow: hidden;
        width: calc(100% - 100px);

        .seLi {
          height: 35px;
          padding: 0 20px;
          border: 1px solid #d4d4d4;
          border-radius: 5px;
          color: #888;
          margin-right: 15px;
          float: left;
          cursor: pointer;
          margin-bottom: 15px;
        }

        .on {
          border: 1px solid #1382eb;
          background-color: #1382eb;
          color: #fff;
        }
      }
    }

    .mab15 {
      margin-bottom: 15px;
    }
  }

  .btns {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
    padding-bottom: 30px;

    .btn {
      margin-right: 30px;
      cursor: pointer;
      height: 40px;
      border-radius: 5px;
      width: 90px;
      box-sizing: border-box;
      border: 1px solid #ebebeb;
    }

    .btn:last-child {
      color: #fff;
      background-color: #1382eb;
      margin-right: 0;
    }
  }
}

.contentRit {
  width: 490px;
  box-sizing: border-box;
  background-color: #f5f7f8;
  padding: 20px 30px;
  padding-right: 30px;

  .titleBox {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .shu {
      width: 4px;
      border-radius: 4px;
      height: 20px;
      background-color: #1382eb;
    }

    .name {
      font-weight: 600;
      font-size: 16px;
      margin-left: 10px;
    }
  }

  .tyTxt {
    margin-top: 5px;
    font-size: 12px;
    color: #999;

    span {
      color: #1382eb;
    }
  }

  .xyCont {
    border: 1px solid #f0cbcb;
    border-radius: 5px;
    width: 300px;
    background: linear-gradient(to bottom,
        #ffe3e3,
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 0));
    margin-top: 20px;

    .xyHead {
      display: flex;
      align-items: center;
      padding: 10px 10px 0;
      font-size: 14px;

      .zt {
        font-size: 12px;
        padding: 2px 5px;
        border-radius: 5px;
        background-color: #fadfd4;
        margin-left: 5px;
        color: #ee4a09;
      }
    }

    .txt {
      padding: 5px 10px 10px;
      font-size: 12px;
      color: #888;
      border-bottom: 1px solid #ebebeb;
    }

    .ts {
      padding: 10px 10px;
      font-size: 12px;
      color: #434;
    }
  }

  .typeList {
    padding-top: 40px;

    .typeBox {
      height: 45px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      padding: 0 15px;
      border-radius: 5px;

      .box {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #9c9c9c;

        .enter {
          font-size: 12px;
          padding-left: 12px;
        }
      }
    }

    .on {
      background-color: #d3e4f8;
      color: #1382eb;

      .box {
        color: #1382eb;
      }
    }
  }
}
</style>
